import request from '@/services/axios'

export interface ParsedDocument {
  text?: string | null
  csvSheets?: Array<{ csv?: string | null } | null> | null
}

export const parseDocument = async (file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  if (file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')) {
    formData.append('pdfStartPage', '1')
    formData.append('pdfEndPage', '10')
  }
  // 由 Vite / Nginx 单独代理到文档解析服务。
  const response = await request.fileUpload('/api/v1/documents/parse', formData) as {
    data?: ParsedDocument | null
    msg?: string
  }
  if (!response.data) {
    throw new Error(response.msg || '文档解析失败')
  }
  return response.data
}
